import { ref } from 'vue'

import { defineStore } from 'pinia'
import { saleApi } from '@/apis/sale.api'

import { useWebSiteStore } from '@/stores/web-site.store'

import { getTranslatedItems } from '@/plugins/i18n'

import { useGetOrFetchAsync } from '@/composables/store'

export const useSaleStore = defineStore('sale', () => {
  const webSiteStore = useWebSiteStore()

  const api = saleApi
  const saleReasons = ref([])
  const electronicInvoiceCredit = ref(null)
  const electronicInvoiceLastUpdate = ref(null)
  const electronicInvoiceCreditOptions = {
    minCreditsBeforeWarning: 10,
    color: '#2196f3',
    warningColor: 'red',
  }

  const fetchElectronicInvoiceCreditsAsync = async(force = false) => {
    await useGetOrFetchAsync(electronicInvoiceCredit, () => webSiteStore.api.getCreditsAsync({ credit_type: webSiteStore.platformCreditsType.ELECTRONIC_INVOICE }), force)
    electronicInvoiceLastUpdate.value = new Date()
  }

  const fetchSaleReasonsAsync = async() => {
    const res = await saleApi.getSaleReasonsAsync()
    if (res.data) {
      saleReasons.value = res.data
    }
  }

  const fetchClipboardRowsAsync = async() => saleApi.get(saleApi.clipboardRowsUrl)

  const getOrFetchElectronicInvoiceCreditsAsync = async(force = false) => {
    if (force) {
      await fetchElectronicInvoiceCreditsAsync(force)
    } else {
      await webSiteStore.fetchEntityLastUpdateAsync(useSaleStore(), () => saleApi.getLastUpdate(saleApi.electronicInvoiceUrl), null, 'sale.models.ElectronicInvoiceCredit')
    }
    return {
      value: electronicInvoiceCredit.value?.credits,
      updated_at: electronicInvoiceLastUpdate.value,
      expiration_date: electronicInvoiceCredit.value?.credits > 0 ? new Date(new Date().getFullYear(), 11, 31) : null
    }
  }

  const generateSaleDocumentAsync = async(data) => {
    await saleApi.generateSaleDocumentFromWorksheet(data)
  }

  const getLocalizedSaleReasons = () => getTranslatedItems(saleReasons.value)

  const $reset = () => {
    saleReasons.value = []
    electronicInvoiceCredit.value = null
    electronicInvoiceLastUpdate.value = null
  }

  return {
    api,
    saleReasons,
    electronicInvoiceCredit,
    electronicInvoiceCreditOptions,
    electronicInvoiceLastUpdate,
    fetchSaleReasonsAsync,
    fetchElectronicInvoiceCreditsAsync,
    fetchClipboardRowsAsync,
    generateSaleDocumentAsync,
    getLocalizedSaleReasons,
    getOrFetchElectronicInvoiceCreditsAsync,
    $reset,
  }
}, {
  persist: [
    {
      pick: ['saleReasons', 'electronicInvoiceCredit', 'electronicInvoiceLastUpdate'],
      storage: localStorage
    }
  ]
})
